// Components
import { Text } from 'yard-utilities/components'

import styles from './Span.module.sass'

interface SpanProps
  extends React.HTMLAttributes<
    [HTMLParagraphElement, HTMLHeadingElement, HTMLSpanElement]
  > {
  children: React.ReactNode
  textColor?: string
  variant?: string
  fontWeight?: 400 | 600 | 700 | 800
  decoration?: 'underline' | 'lineThrough'
  transform?: 'uppercase'
  highlighted?: boolean
  fontFamily?: string
}

const Span = ({
  children,
  textColor = 'inherit',
  variant = 'inherit',
  fontWeight,
  decoration,
  transform,
  highlighted = false,
  fontFamily,
  ...rest
}: SpanProps) => {
  const { onClick, className, ...restProps } = rest

  return (
    <Text
      tagName="span"
      variant={variant}
      textColor={textColor}
      fontWeight={fontWeight}
      decoration={decoration}
      transform={transform}
      fontFamily={fontFamily}
      onClick={onClick}
      role={onClick ? 'button' : ''}
      className={`${styles.span} ${highlighted ? styles.highlighted : ''} ${
        className || ''
      }`}
      {...restProps}
    >
      {children}
    </Text>
  )
}

export default Span
